import Vue from 'vue'
import Vuex from 'vuex'
import fachada from './modules/fachada'
import areas from './modules/areas'
import images from './modules/images'
import users from './modules/users'
import trabajosLibres from './modules/trabajosLibres'
import expos from './modules/expo'
import stand from './modules/stand'
import componentes from './modules/componentes'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  namespaced: true,
  modules: {
    fachada,
    areas,
    images,
    users,
    trabajosLibres,
    expos,
    stand,
    componentes
  }
  // plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js